interface CardProps {
  image: string;
  text: React.ReactNode;
}

const FeatureCard: React.FC<CardProps> = ({ image, text }) => {
  return (
    <div className="flex flex-col items-center space-y-2">
      <div className="rounded-full p-6 border">
        <img
          src={image}
          className="w-12 h-12"
        />
      </div>
      <p className="text-center font-light text-lg">{text}</p>
    </div>
  );
};

export default FeatureCard;
